<script setup>
import {reactive, onMounted, watch} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import {Permissions} from "@/Utils/Permissions";

const props = defineProps({
  start: String,
  end: String
});

const emit = defineEmits(['closed']);

const data = reactive({
  startDate: props.start,
  endDate: props.end,
  dataLoading: false,
  adjusters: [],
  reviewers: [],
  clients: [],
  assigners: [],
  headers: [
    { title: 'Name', key: 'name' },
    { title: 'Total Claims', key: 'total' },
    { title: 'Returned Claims', key: 'returned' },
    { title: '% Returned', key: 'percent_returned' },
  ],
  assignerHeaders: [
    { title: 'Name', key: 'id' },
    { title: 'Task Description', key: 'description' },
    { title: 'Total Created', key: 'total' },
  ]
});

const getData = () =>{
  data.loading = true;
  ApiWrapper.post('corrections', 'list', {
    startDate: data.startDate,
    endDate: data.endDate
  })
    .then((response) => {
      if(response){
        if(response.adjuster){
          data.adjusters = response.adjuster
        }
        if(response.reviewer){
          data.reviewers = response.reviewer
        }
        if(response.client){
          data.clients = response.client
        }
        if(response.assigner){
          data.assigners = response.assigner
        }
      }
    })
    .catch((err) => {
      ToastUtil.error(err);
    })
    .finally(()=> {
      close()
      data.loading = false
    })
}

const close = () => {
  emit('closed');
}

watch(()=>props.start,(newStart)=>{
  data.startDate = newStart;
  getData();
})

watch(()=>props.end,(newEnd)=>{
  data.endDate = newEnd;
  getData();
})

onMounted(()=>{
  getData();
})
</script>

<template>
  <v-container fluid>
    <v-card>
      <v-card-item>
        <v-card-title>
          Corrections By Group
        </v-card-title>
      </v-card-item>
      <v-card-item>
        <v-card>
          <v-card-item>
            <v-card-title>
              Adjusters
            </v-card-title>
          </v-card-item>
          <v-card-item>
            <v-data-table
                density="compact" :items="data.adjusters" :headers="data.headers" :loading="data.dataLoading"
            ></v-data-table>
          </v-card-item>
        </v-card>
        <v-card>
          <v-card-item></v-card-item>
          <v-card-title>
            Reviewers
          </v-card-title>
          <v-card-item></v-card-item>
          <v-card-text>
            <v-data-table
                density="compact" :items="data.reviewers" :headers="data.headers" :loading="data.dataLoading"
            ></v-data-table>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-item></v-card-item>
          <v-card-title>
            Clients
          </v-card-title>
          <v-card-item></v-card-item>
          <v-card-text>
            <v-data-table
                density="compact" :items="data.clients" :headers="data.headers" :loading="data.dataLoading"
            ></v-data-table>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-item></v-card-item>
          <v-card-title>
            Task Assigners
          </v-card-title>
          <v-card-item></v-card-item>
          <v-card-text>
            <v-data-table
                density="compact" :items="data.assigners" :headers="data.assignerHeaders" :loading="data.dataLoading"
            >
              <template v-slot:[`item.name`]="{ item }">
                <RouterLink :to="`/userprofile/${item.id}`" v-if="Permissions.checkPermissions(['users.read'])">
                  {{item.name}}
                </RouterLink>
                <p v-else>
                  {{item.name}}
                </p>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-item>
    </v-card>
  </v-container>
</template>

<style scoped>

</style>